import { useTranslation } from "react-i18next";
import BarPlot from "../charts/BarPlot";
import DashboardBlockShell from "./DashboardBlockShell";
import BooleanStatsPanel from "./BooleanStatsPanel";
import CategoricalStatsPanel from "./CategoricalStatsPanel";

export default function Bloc5BlockSection({
  id,
  title,
  description,
  loading = false,
  error = null,
  itemsByField,
}) {
  const { t } = useTranslation();
  const boolStats = itemsByField["bloc5.wasteObserved"]?.stats || null;
  const categoryStats = itemsByField["bloc5.wasteCategory"]?.stats || null;
  const boolChartItems = [
    { category: t("common.yes", "Sí"), count: boolStats?.yes || 0 },
    { category: t("common.no", "No"), count: boolStats?.no || 0 },
  ];
  const categoryChartItems = (categoryStats?.items || []).map((item) => ({
    category: item.category,
    count: item.count,
  }));

  return (
    <DashboardBlockShell
      id={id}
      title={title}
      description={description}
      loading={loading}
      loadingText={t("dashboard.blocks.bloc5.loading", "Carregant estadístiques de bloc5…")}
      error={error}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BooleanStatsPanel
            title={t("dashboard.blocks.bloc5.wastePresence", "Presència de residus")}
            stats={boolStats}
          />
          <CategoricalStatsPanel
            title={t("dashboard.blocks.bloc5.wasteCategories", "Categories de residus")}
            stats={categoryStats}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BarPlot
            title={t(
              "dashboard.blocks.bloc5.wasteCategoryDistribution",
              "Distribució de categories de residus"
            )}
            items={categoryChartItems}
          />

          <BarPlot
            title={t(
              "dashboard.blocks.bloc5.yesNoWaste",
              "Respostes sí/no sobre residus"
            )}
            items={boolChartItems}
          />
        </div>
      </div>
    </DashboardBlockShell>
  );
}
